import http from "../http-common";

const getAll = () => {
  return http.get(`/Pages`);
};

const get = id => {
  return http.get(`/Pages/${id}`);
};

const create = data => {
  return http.post(`/Pages`, data);
};

const update = (id, data) => {
  return http.put(`/Pages/${id}`, data);
};

const remove = id => {
  return http.delete(`/Pages/${id}`);
};

const removeAll = () => {
  return http.delete(`/Pages`);
};

const findByTitle = title => {
  return http.get(`/Pages?title=${title}`);
};

const PageService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  findByTitle
};

//export default PageService;
export {PageService};